import axios from 'axios';

const axiosInstance = axios.create({
//   baseURL: 'http://www.teleradb.com/api'
    // baseURL: 'http://localhost:3001/api/v0'
    baseURL: 'https://loudkfrn7d.execute-api.us-east-1.amazonaws.com/latest/api/v0'
});

export const search = {
    quick: (text) => axiosInstance.get(`/search?name="${text}"`),
    tags: () => axiosInstance.get(`/search/tags`),
    categories: () => axiosInstance.get(`/search/categories`),
};

export const items = {
    get: (itemKey) => axiosInstance.get(`/items/${itemKey}`),
    search: (text = '', categories = [], tags = [], skip = 0, limit = 50, csv = "false", minimumLevel, maximumLevel, minimumiLevel, maximumiLevel) => 
        axiosInstance.get(`/items?name=${text}&categories=${categories}&tags=${tags}&skip=${skip}&limit=${limit}&export=${csv}&min_level=${minimumLevel}&max_level=${maximumLevel}&min_ilevel=${minimumiLevel}&max_ilevel=${maximumiLevel}`),
};

export const itemsets = {
    get: (id) => axiosInstance.get(`/itemsets/${id}`),
};

export const appearances = {
    get: (id) => axiosInstance.get(`/appearances/${id}`),
    slots: () => axiosInstance.get('/appearances/slots'),
    types: () => axiosInstance.get('/appearances/types'),
    search: (text = '', slots = [], types = [], tags = [], skip = 0, limit = 48) =>
        axiosInstance.get(`/appearances?name=${text}&slot=${slots}&type=${types}&tags=${tags}&skip=${skip}&limit=${limit}`),
};


// WEBPACK FOOTER //
// ./src/api.js